import requst from "./request";

// 获取轮播图数据
export const getCmsapiSildeshow = () => requst.get("/cmsapi/getSlideshow");
